import './PlanLabelField.style.less'

interface Prop {
  label: string
}

export function PlanLabelField(prop: Prop) {
  const { label } = prop

  return (
    <div className="sub-section-label">
      <span>{label}</span>
    </div>
  )
}
